import React, { PropsWithChildren } from 'react'

import { PropsWithClassName } from '@helper/PropsWithClassName'

import { ImageSliderSlide } from '@definitions/types/storyblokTypes'

import {
  StyledImage,
  StyledSwiperSlide,
} from './StoryblokImageSliderSlide.styles'

interface Props extends PropsWithClassName {
  blok: ImageSliderSlide
}

const StoryblokImageSliderSlide: React.FC<PropsWithChildren<Props>> = (
  props: PropsWithChildren<Props>
): React.JSX.Element => {
  const { blok } = props
  console.log(JSON.stringify(blok))
  
  // Guard against missing Image data
  if (!blok.Image || !blok.Image.filename) {
    return (
      <StyledSwiperSlide
        className={props.className}
        data-testid={'storyblok-image-slider-slide-root'}
      >
        {/* Render empty slide if image is missing */}
      </StyledSwiperSlide>
    )
  }
  
  return (
    <StyledSwiperSlide
      className={props.className}
      data-testid={'storyblok-image-slider-slide-root'}
    >
      <StyledImage
        priority
        src={blok.Image.filename}
        alt={blok.Image.alt ?? 'No Alt Text'}
        fill
      />
    </StyledSwiperSlide>
  )
}

export { StoryblokImageSliderSlide }
